import React, { useEffect } from 'react';
import Panel from '../../layout/Panel';
import { Analytics as SliceIcon } from '@mui/icons-material';
import SliceCore from './SliceCore';

class SliceErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // Log detailed info to console for now
    console.error('SliceErrorBoundary caught error', error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 16, fontFamily: 'monospace', fontSize: 13 }}>
          <strong>Slice Render Error:</strong>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{String(this.state.error.message || this.state.error)}</pre>
          <p>Check console for stack trace. UI left in recoverable state.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Slice() {
  useEffect(() => {
    console.log('[SliceMount] index.jsx mounted');
  }, []);
  return (
    <Panel 
      title="Slice"
      icon={<SliceIcon />}
      contentSx={{ p: 2 }}
    >
      <SliceErrorBoundary>
        <SliceCore />
      </SliceErrorBoundary>
    </Panel>
  );
}
